import { ComponentType, MouseEvent, MouseEventHandler } from "react";

import { analytics } from "~~/helpers";

export interface ClickAnalyticsProps {
  ariaLabel?: string;
  analyticsId?: string;
  analyticsProps?: Record<string, string | number | boolean>;
  onClick?: MouseEventHandler;
  isDisabled?: boolean;
}

export const withClickAnalytics =
  <T extends object>(WrappedComponent: ComponentType<T>) =>
  ({
    ariaLabel,
    analyticsId,
    analyticsProps = {},
    onClick,
    ...props
  }: T & ClickAnalyticsProps): JSX.Element => {
    const handleClick = (e: MouseEvent): void => {
      if (props.isDisabled) {
        return;
      }

      // If no analyticsId is provided, use the ariaLabel
      let finalAnalyticsId = analyticsId;
      if (!finalAnalyticsId && ariaLabel) {
        finalAnalyticsId = `click ${ariaLabel.toLowerCase()}`;
      }

      if (finalAnalyticsId) {
        analytics
          .trackWebEvent(finalAnalyticsId, {
            ...analyticsProps,
          })
          .catch(console.error);

        // Flush incase we redirect from this click
        analytics.flush();
      }
      onClick?.(e);
    };
    return <WrappedComponent onClick={handleClick} {...(props as T)} />;
  };
